import { apiClient } from "@/lib/api-client";

export const getKonstantaFungsional = async ({
  niu,
  year,
  semester,
  periodeID,
  month,
}: {
  niu: string;
  year: number | string;
  semester: number | string;
  periodeID: string | number;
  month?: string;
}) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    periodeID: periodeID.toString(),
  });

  if (month) {
    params.append("month", month);
  }

  const res = await apiClient<any>(
    `${baseUrl}/api/v1/konstanta-fungsional/${niu}?${params.toString()}`,
    {
      method: "GET",
    },
  );

  return res.datas;
};
